export const escape_html = function (text) {
    return text
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
};
export const nl2br = (text) => text.replace(/\n/g, '<br/>');
